import { AxiosRequestConfig } from 'axios';
import { Autocomplete, AutocompleteProps } from '@mui/material';

import { Organization } from '@/types';
import { useGetOrganizationsQuery } from '@/services';
import { useAsyncSearch } from '@/hooks';

function SearchOrganizations<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>({
  config,
  value,
  getOptions,
  prefetch,
  ...props
}: {
  config?: AxiosRequestConfig<Organization>;
  getOptions?(options: readonly Organization[]): void;
  prefetch?: boolean;
} & Omit<AutocompleteProps<Organization, Multiple, DisableClearable, FreeSolo>, 'options'>) {
  const asyncGetOrganizationsQueryProps = useAsyncSearch<Organization, Multiple, DisableClearable, FreeSolo>(
    useGetOrganizationsQuery,
    'id',
    value,
    config,
    getOptions,
    prefetch,
  );

  return <Autocomplete {...props} {...asyncGetOrganizationsQueryProps} />;
}

export default SearchOrganizations;
